import { Component, OnInit, ChangeDetectorRef, HostListener } from "@angular/core";
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { CommonService } from 'wire-frame';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs/operators';


import { TagModule } from 'primeng/tag';
import { DropdownModule } from 'primeng/dropdown';
import { ToolbarModule } from 'primeng/toolbar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ConfirmationService } from 'primeng/api';
import { EditorModule } from 'primeng/editor';
import { ButtonModule } from 'primeng/button';
import { TabViewModule } from 'primeng/tabview';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { AutoCompleteModule } from "primeng/autocomplete";
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';

import { PatientRegistrationService } from '../../../service/admin/patient-registration.service';
import { ClinicService } from '../../../service/admin/clinic.service';

import { PrescriptionsService } from '../../../service/admin/prescriptions.service';

import { ApiService } from '../../../service/admin/api.service';
import { ToasterService } from '../../../service/common/toaster.service';
import { ALL_COUNTRIES, COUNTRY_CITY_TIERS, TieredCities } from './location-data';
import { INDIA_ALL_CITIES_BY_STATE } from './india-all-cities';
import { PhoneFormatPipe } from '../../../phone-format.pipe';
import {
  finalizePatientAgeInput,
  formatPatientAgeForDisplay,
  getPatientAgeError,
  isValidPatientAge,
  normalizePatientAgeForStorage,
  normalizePatientAgeInput,
  PATIENT_AGE_HINT,
} from '../../../shared/patient-age.util';


@Component({
  selector: 'app-patient-registration',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    TagModule,
    DropdownModule,
    ToolbarModule,
    ConfirmDialogModule,
    ConfirmPopupModule,
    EditorModule,
    ButtonModule,
    TabViewModule,
    ScrollPanelModule,
    AutoCompleteModule,
    DialogModule,
    TableModule,
    PhoneFormatPipe
  ],
  providers: [ConfirmationService, CommonService, PatientRegistrationService, ClinicService, PrescriptionsService, ApiService],
  templateUrl: './patient-registration.component.html',
  styleUrls: ['./patient-registration.component.scss']
})
export class PatientRegistrationComponent implements OnInit {
  activeIndex: number = 0;
  patientIndex: number = 0;

  public patientList: any[] = [];
  public patientListPagination = {
    current_page: 1,
    per_page: 10,
    total: 0,
    last_page: 1
  };
  public cardList: any[] = [];
  public clinicList: any[] = [];
  public patientDialogVisible: boolean = false;
  public searchTerm: string = '';
  public selectedStatusFilter: string = 'all';
  public selectedModeFilter: string = 'all';
  public sortField: string = 'id';
  public sortDirection: 'asc' | 'desc' = 'desc';
  public currentPage = 1;
  public pageSize = 10;
  public pageSizeOptions = [10, 20, 50, 100];

  public patient: any = {
    id: 0,
    clinic_id: 1,
    first_name: '',
    middle_name: '',
    last_name: '',
    age: 0,
    blood_group: '',
    gender: '',
    primary_contact: '',
    secondary_contact: '',
    address: '',
    city: '',
    state: '',
    country: 'India',
    pincode: '',
    marital_status: '',
    referred_by: '',
    visit_fees: 0,
    is_courier: 'OPD',
  };

  readonly patientAgeHint = PATIENT_AGE_HINT;
  readonly isValidPatientAge = isValidPatientAge;
  patientAgeError: string | null = null;

  public patientsList: any[] = [];

  public activeMenu: string = 'personal';

  public isPatientVisible: boolean = true;
  public openUploadReportDialog: boolean = false;
  public openPaymentDialog: boolean = false;
  public queue: any[] = [];
  public selectedPatient: any;

  private apiUrl: string | undefined;

  public uploadsByDate: { date: Date, files: any[] }[] = [];
  public pendingFiles: File[] = [];
  public reportTextTitle: string = '';
  public reportTextContent: string = '';
  public isSavingTextReport: boolean = false;
  public currentPatientId: number = 0;
  public paymentHistory: any[] = [];

  public pagination = {
    current_page: 1,
    per_page: 20,
    total: 0,
    last_page: 1,
    has_more: false
  };

  public selectedDueAmount: number = 0;
  public selectedPrescriptionId: number = 0;

  latestDueAmount = 0;
  latestDuePayment: any = null;

  queryDueAmount: number = 0;
  queryPrescriptionId: number = 0;

  payAmount: number | null = null;

  paymentModes = [
    { label: 'Cash', value: 'cash' },
    { label: 'UPI', value: 'upi' },
    { label: 'Card', value: 'card' },
    { label: 'Cheque', value: 'cheque' }
  ];

  selectedPaymentMode: string | null = null;
  settlingPayment = false;

  pendingRegistrations: any[] = [];
  pendingLoading = false;
  showPendingPanel = false;
  showOnlineQueue = false;
  pendingCount = 0;
  pendingStatusFilter: 'pending' | 'approved' | 'rejected' = 'pending';
  pendingSearch = '';
  pendingPage = 1;
  pendingPerPage = 25;
  pendingTotal = 0;
  pendingLastPage = 1;
  pendingFrom = 0;
  pendingTo = 0;
  selectedPendingRegistration: any | null = null;
  rejectingId: number | null = null;
  rejectReason = '';
  private pendingSearchTimer?: ReturnType<typeof setTimeout>;
  private patientSearchTimer?: ReturnType<typeof setTimeout>;

  allCountries = ALL_COUNTRIES;
  indiaAllCitiesByState = INDIA_ALL_CITIES_BY_STATE;
  countryCityTiers = COUNTRY_CITY_TIERS;
  countrySuggestions: string[] = [];
  stateSuggestions: string[] = [];
  citySuggestions: string[] = [];

  patientModeOptions = [
    { label: 'OPD', value: 'OPD' },
    { label: 'Courier', value: 'COURIER' },
    { label: 'NRI', value: 'NRI' }
  ];

  
  maritalStatusOptions = [
    { label: 'Single', value: 'Single' },
    { label: 'Married', value: 'Married' },
    { label: 'Divorced', value: 'Divorced' },
    { label: 'Widowed', value: 'Widowed' }
  ];

  get filteredPatients(): any[] {
    return [...(this.patientList || [])].sort((a: any, b: any) => {
      const aValue = String(a?.[this.sortField] ?? '').toLowerCase();
      const bValue = String(b?.[this.sortField] ?? '').toLowerCase();
      if (aValue < bValue) return this.sortDirection === 'asc' ? -1 : 1;
      if (aValue > bValue) return this.sortDirection === 'asc' ? 1 : -1;
      return 0;
    });
  }

  get totalPages(): number {
    return Math.max(1, this.patientListPagination.last_page || 1);
  }

  get paginatedPatients(): any[] {
    return this.filteredPatients;
  }


  constructor(
    public common: CommonService,
    private toast: ToasterService,
    private confirmationService: ConfirmationService,
    private patientRegistrationService: PatientRegistrationService,
    private clinicService: ClinicService,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
    private apiService: ApiService,
    private prescriptionsService: PrescriptionsService,
    private route: ActivatedRoute
  ) {
    this.apiUrl = this.apiService.getBaseUrl();
    this.common.breadCrum = {
      title: 'Visa Card Master',
      icon: 'user',
      list: ['Visa Card Master'],
    };
  }

  ngOnInit() {
    this.getPatient(1, this.pageSize);
    this.getClinic();
    this.loadPendingRegistrations();
    this.refreshLocationSuggestions();
    // this.getCards();

    // Only process query params if navigating through the router with specific parameters
    this.route.queryParams.pipe(take(1)).subscribe(params => {
      const patientId = Number(params['patientId']);
      const prescriptionId = params['prescriptionId'];
      const dueAmount = params['dueAmount'];
      const openDues = params['openDues'];

      // Only open payment dialog if explicitly navigated with these params
      if (openDues === 'true' || openDues === true) {
        if (prescriptionId) {
          this.queryPrescriptionId = Number(prescriptionId);
        }
        if (dueAmount) {
          this.queryDueAmount = Number(dueAmount);
        }
        if (patientId > 0) {
          this.openPaymentHistoryDialog(patientId);
        }
      }
    });
  }

  openAddPatientDialog() {
    this.clearForm();
    this.patientDialogVisible = true;
  }

  openEditPatientDialog(item: any) {
    this.patient = { ...item };
    this.patient.age = formatPatientAgeForDisplay(this.patient.age);
    this.patient.is_courier = this.normalizePatientMode(this.patient.is_courier);
    this.patientAgeError = getPatientAgeError(this.patient.age);
    this.refreshLocationSuggestions();
    this.patientDialogVisible = true;
  }

  openReportsDialog(item: any) {
    this.currentPatientId = item.id;
    this.prescriptionsService.getReportsByPatientId(item.id).subscribe((rRes: any) => {
      this.uploadsByDate = rRes.success ? rRes.data : [];
    });
    this.openUploadReportDialog = true;
  }

  openPaymentsDialog(item: any) {
    this.currentPatientId = item.id;
    this.openPaymentHistoryDialog(item.id);
  }

  confirmTogglePatient(item: any) {
    const nextStatus = String(item?.is_active || '').toLowerCase() === 'active' ? 'inactive' : 'active';
    this.confirmationService.confirm({
      header: 'Update Patient Status',
      message: `Change status for ${item?.full_name || 'this patient'} to ${nextStatus}?`,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Confirm',
      rejectLabel: 'Cancel',
      accept: () => this.deletePatient(item),
    });
  }

  setSort(field: string) {
    if (this.sortField === field) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortField = field;
      this.sortDirection = 'asc';
    }
    this.currentPage = 1;
  }

  clearFilters() {
    this.searchTerm = '';
    this.selectedStatusFilter = 'all';
    this.selectedModeFilter = 'all';
    this.currentPage = 1;
    this.getPatient(1, this.pageSize);
  }

  onSearchTermChange() {
    this.currentPage = 1;
    if (this.patientSearchTimer) {
      clearTimeout(this.patientSearchTimer);
    }
    this.patientSearchTimer = setTimeout(() => {
      this.getPatient(1, this.pageSize);
    }, 300);
  }

  applyPatientFilters() {
    this.currentPage = 1;
    this.getPatient(1, this.pageSize);
  }

  updatePageSize() {
    this.currentPage = 1;
    this.getPatient(1, this.pageSize);
  }

  goToPreviousPage() {
    if (this.currentPage > 1) {
      this.getPatient(this.currentPage - 1, this.pageSize);
    }
  }

  goToNextPage() {
    if (this.currentPage < this.totalPages) {
      this.getPatient(this.currentPage + 1, this.pageSize);
    }
  }

  getPatient(page: number = this.patientListPagination.current_page, perPage: number = this.patientListPagination.per_page) {
    const normalizedPage = Number(page) > 0 ? Number(page) : 1;
    const normalizedPerPage = Number(perPage) > 0 ? Number(perPage) : this.patientListPagination.per_page;

    this.patientRegistrationService.getPatient({
      page: normalizedPage,
      per_page: normalizedPerPage,
      search: (this.searchTerm || '').trim(),
      status: this.selectedStatusFilter,
      mode: this.selectedModeFilter,
    }).subscribe((res: any) => {
      const source = Array.isArray(res?.data) ? res.data : [];
      const normalized: any[] = new Array(source.length);

      for (let i = 0; i < source.length; i++) {
        const patient = source[i] || {};
        const firstName = String(patient.first_name || '').trim();
        const middleName = String(patient.middle_name || '').trim();
        const lastName = String(patient.last_name || '').trim();
        const composedFullName = [firstName, middleName, lastName].filter(Boolean).join(' ').trim();
        const fallbackName = composedFullName || String(patient.full_name || '').trim();

        normalized[i] = {
          ...patient,
          full_name: fallbackName,
          is_active: patient.is_active === true || patient.is_active === '1' || patient.is_active === 1 ? 'Active' : 'Inactive',
          isCourier: this.normalizePatientMode(patient.is_courier)
        };
      }

      this.patientList = normalized.sort((a: any, b: any) => {
        const aCreated = a?.created_at ? new Date(a.created_at).getTime() : 0;
        const bCreated = b?.created_at ? new Date(b.created_at).getTime() : 0;
        if (aCreated !== bCreated) return bCreated - aCreated;

        const aId = Number(a?.id) || 0;
        const bId = Number(b?.id) || 0;
        return bId - aId;
      });

      const pagination = res?.pagination || res?.meta?.pagination || null;
      if (pagination) {
        this.patientListPagination.current_page = Number(pagination.current_page || normalizedPage) || normalizedPage;
        this.patientListPagination.per_page = Number(pagination.per_page || normalizedPerPage) || normalizedPerPage;
        this.patientListPagination.total = Number(pagination.total || source.length) || source.length;
        this.patientListPagination.last_page = Number(pagination.last_page || 1) || 1;
        this.currentPage = this.patientListPagination.current_page;
        this.pageSize = this.patientListPagination.per_page;
      } else {
        this.patientListPagination.current_page = normalizedPage;
        this.patientListPagination.per_page = normalizedPerPage;
        this.patientListPagination.total = source.length;
        this.patientListPagination.last_page = 1;
      }
    });
  }

  private normalizePatientMode(mode: any): 'OPD' | 'COURIER' | 'NRI' {
    if (mode === 'NRI') {
      return 'NRI';
    }

    if (
      mode === true ||
      mode === 'true' ||
      mode === 1 ||
      mode === '1' ||
      mode === 'Courier' ||
      mode === 'COURIER'
    ) {
      return 'COURIER';
    }

    return 'OPD';
  }

  getClinic() {
    this.clinicService.getClinic().subscribe({
      next: (res: any) => {
        this.clinicList = Array.isArray(res.data)
          ? res.data.map((clinic:any) => ({
              label: clinic.name,
              value: clinic.id
            }))
          : [];
      },
      error: (err) => {
        console.error('Clinic API error:', err);
        this.clinicList = [];
      }
    });
  }

  updateFullName(): void {
    const salutation = this.patient.salutation ? this.patient.salutation + ' ' : '';
    const patientName = this.patient.patientName ? this.patient.patientName : '';
    this.patient.fullName = salutation + patientName;
  }

  onPatientAgeChange(value: string | number | null): void {
    this.patient.age = normalizePatientAgeInput(value);
    this.patientAgeError = getPatientAgeError(this.patient.age);
  }

  onPatientAgeBlur(): void {
    this.patient.age = finalizePatientAgeInput(this.patient.age);
    this.patientAgeError = getPatientAgeError(this.patient.age);
  }

  closeForm(): void {
    this.clearForm();
    this.patientDialogVisible = false;
  }

  clearForm(): void {
    this.patient = {
      clinic_id: 1,
      first_name: '',
      middle_name: '',
      last_name: '',
      age: 0,
      blood_group: '',
      gender: '',
      primary_contact: '',
      secondary_contact: '',
      address: '',
      city: '',
      state: '',
      country: 'India',
      pincode: '',
      marital_status: '',
      referred_by: '',
      visit_fees: 0,
      is_courier: 'OPD',
    };

    this.pendingFiles = [];
    this.patientAgeError = null;
    this.refreshLocationSuggestions();
  }

  processPatient() {
    this.patient.age = finalizePatientAgeInput(this.patient.age);
    this.patientAgeError = getPatientAgeError(this.patient.age);

    if (!isValidPatientAge(this.patient.age)) {
      this.toast.add({
        severity: 'warn',
        summary: 'Invalid age',
        detail: getPatientAgeError(this.patient.age) || 'Please enter a valid age.',
      });
      return;
    }

    if (this.patient?.id) {
      this.updatePatient();
    } else {
      this.addPatient();
    }
  }

  addPatient() {
    const payload = {
      ...this.patient,
      age: normalizePatientAgeForStorage(this.patient.age) ?? this.patient.age,
      is_courier: this.normalizePatientMode(this.patient.is_courier)
    };

    this.patientRegistrationService.addPatient(payload).subscribe((res: any) => {
      if (res.data) {
        this.toast.add({ severity: 'success', summary: 'Success', detail: res.message });
        this.getPatient();
        this.closeForm();
      } else {
        this.toast.add({ severity: 'error', summary: 'Error', detail: res.message });
      }
    });
  }

  updatePatient(): void {

    const payload = {
      ...this.patient,
      age: normalizePatientAgeForStorage(this.patient.age) ?? this.patient.age,
      is_courier: this.normalizePatientMode(this.patient.is_courier)
    };
    delete payload.is_active;

    this.patientRegistrationService.updatePatient(payload).subscribe((res: any) => {
      if (res.data) {
        this.toast.add({ severity: 'success', summary: 'Success', detail: res.message });
        this.getPatient();
        this.closeForm();
      } else {
        this.toast.add({ severity: 'error', summary: 'Error', detail: res.message });
      }
    });
  }

  deletePatient(item: any): void {
    this.patientRegistrationService.toggleActive(item.id).subscribe((res: any) => {
      this.toast.add({ severity: 'success', summary: 'Success', detail: 'Patient active status updated successfully' });
      this.getPatient();
      this.closeForm();
    });
  }

  private getAuthHeaders() {
    const token = localStorage.getItem('jwtToken');
    return {
      headers: new HttpHeaders({
        'Authorization' : `Bearer ${token}`
      })
    }
  }

  searchPatients(event: any) {
    const query = event.query;
    this.http.get<any>(this.apiUrl + '/patient/search', { params: { q: query }, ...this.getAuthHeaders()})
      .subscribe(res => {
        if (!res.data || res.data.length === 0) {
          this.patientsList = [];
          this.toast.add({
            severity: 'info',
            summary: 'Info',
            detail: `No patients found for "${query}".`
          });
        } else {
          this.patientsList = res.data.map((p: any) => ({
            ...p,
            full_name: `${p.full_name} (${p.patient_number})`
          }));
        }
        // Stop spinner and update view
        this.cdr.detectChanges();
      }, error => {
        this.patientsList = [];
        this.toast.add({
          severity: 'info',
          summary: 'Info',
          detail: 'No patients found.'
        });
        this.cdr.detectChanges();
      });
  }

  filterCountries(event: any) {
    this.countrySuggestions = this.filterSuggestions(this.allCountries, event?.query);
  }

  filterStates(event: any) {
    const states = this.getStatesForCountry(this.patient.country);
    this.stateSuggestions = this.filterSuggestions(states, event?.query);
  }

  filterCities(event: any) {
    const cities = this.getCitiesForState(this.patient.country, this.patient.state);
    this.citySuggestions = this.filterSuggestions(cities, event?.query);
  }

  onCountrySelected() {
    const isIndia = (this.patient.country || '').toLowerCase() === 'india';
    const validStates = this.getStatesForCountry(this.patient.country);
    if (!isIndia) {
      this.patient.state = '';
    } else if (!validStates.includes(this.patient.state)) {
      this.patient.state = '';
    }
    this.patient.city = '';
    this.refreshLocationSuggestions();
  }

  onStateSelected() {
    const validCities = this.getCitiesForState(this.patient.country, this.patient.state);
    if (!validCities.includes(this.patient.city)) {
      this.patient.city = '';
    }
    this.refreshLocationSuggestions();
  }

  private refreshLocationSuggestions() {
    this.countrySuggestions = this.allCountries;
    this.stateSuggestions = this.getStatesForCountry(this.patient.country);
    this.citySuggestions = this.getCitiesForState(this.patient.country, this.patient.state);
  }

  private getStatesForCountry(country: string): string[] {
    if (!country || country.toLowerCase() !== 'india') {
      return [];
    }
    return Object.keys(this.indiaAllCitiesByState);
  }

  private getCitiesForState(country: string, state: string): string[] {
    if (!country) return [];

    if (country.toLowerCase() === 'india') {
      if (!state || !this.indiaAllCitiesByState[state]) {
        return [];
      }
      return this.indiaAllCitiesByState[state];
    }

    if (!this.countryCityTiers[country]) {
      return [];
    }

    return this.mergeTieredCities(this.countryCityTiers[country]);
  }

  private mergeTieredCities(tiers: TieredCities): string[] {
    return [...tiers.tier1, ...tiers.tier2];
  }

  private filterSuggestions(options: string[], query: string): string[] {
    const q = (query || '').trim().toLowerCase();
    if (!q) return [...options];
    return options.filter(item => item.toLowerCase().includes(q));
  }

  getColorClass(status: string): string {
    switch (status) {
      case 'in progress': return 'bg-light-yellow';
      case 'completed': return 'bg-light-green';
      case 'scheduled': return 'bg-light-blue';
      case 'cancelled': return 'bg-light-red';
      default: return 'bg-light-yellow';
    }
  }

  onFileSelect(event: any) {
    // const files = event.target.files as FileList;
    const files = Array.from(event.target.files as FileList);
    if (!files || files.length === 0) {
      return;
    }

    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
    const maxFileSize = 5 * 1024 * 1024; // 5 MB

    const validFiles: File[] = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      // --- Validation Step 1: File Type ---
      if (!allowedTypes.includes(file.type)) {
        this.toast.add({
          severity: 'error',
          summary: 'Invalid File Type',
          detail: `File '${file.name}' was rejected. Only PDF, JPG, and PNG are allowed.`
        });
        continue; // Skip this file
      }

      // --- Validation Step 2: File Size ---
      if (file.size > maxFileSize) {
        const fileSizeMB = (file.size / 1024 / 1024).toFixed(2);
        this.toast.add({
          severity: 'error',
          summary: 'File Too Large',
          detail: `File '${file.name}' (${fileSizeMB} MB) exceeds the 5 MB limit.`
        });
        continue; // Skip this file
      }

      // If all checks pass, add the file to our valid list
      validFiles.push(file);
    }

    // Now, assign only the validated files to your main property
    this.pendingFiles = validFiles;

    // Optional: Give a summary message if some files were selected
    if (this.pendingFiles.length > 0) {
      this.toast.add({
        severity: 'info',
        summary: 'Files Ready',
        detail: `${this.pendingFiles.length} file(s) are ready to be uploaded.`
      });
    }

    // Reset the file input to allow re-selection of the same file
    event.target.value = '';
  }

  onUploadSelectedFiles() {
    if (!this.pendingFiles || this.pendingFiles.length === 0) {
      this.toast.add({
        severity: 'warn',
        summary: 'No Files',
        detail: 'Please select valid files before uploading.'
      });
      return;
    }

    const today = new Date();

    // 🔹 Find existing group for today, or create a new one
    let group = this.uploadsByDate.find(
      g => new Date(g.date).toDateString() === today.toDateString()
    );

    if (!group) {
      group = { date: today, files: [] };
      this.uploadsByDate.unshift(group);
    }

    const filesToProcessCount = this.pendingFiles.length;
    let processedCount = 0;

    // 🔹 Process each file asynchronously
    this.pendingFiles.forEach(file => {
      const reader = new FileReader();

      reader.onload = (e: any) => {
        // ✅ Push processed file into today's group
        group!.files.push({
          name: file.name,
          type: file.type,
          url: e.target.result, // base64 preview
        });

        processedCount++;

        // ✅ When all files processed, show message and clear queue
        if (processedCount === filesToProcessCount) {
          this.toast.add({
            severity: 'success',
            summary: 'Upload Complete',
            detail: `${filesToProcessCount} file(s) have been successfully added.`
          });

          // 🔹 Only clear after all async FileReaders are done
          // this.pendingFiles = [];

          // Optional: trigger change detection if UI doesn’t auto-update
          // this.cd.detectChanges();
        }
      };

      reader.onerror = () => {
        processedCount++;
        console.error(`Error reading file: ${file.name}`);
        if (processedCount === filesToProcessCount) {
          // this.pendingFiles = [];
        }
      };

      // 🔹 Start reading the file
      reader.readAsDataURL(file);
    });
  }

  openFile(file: any) {
    if (!file) return;

    const kind = String(file?.kind || '').toLowerCase();
    const fileType = String(file?.type || '').toLowerCase();
    const textContent = String(file?.text || '').trim();

    if (kind === 'text' || fileType === 'text/plain') {
      if (!textContent) return;
      const newWindow = window.open();
      if (newWindow) {
        const safeTitle = String(file?.name || 'Text Report').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        const safeText = textContent.replace(/</g, '&lt;').replace(/>/g, '&gt;');
        newWindow.document.write(`
        <html>
          <head>
            <title>${safeTitle}</title>
            <link rel="preconnect" href="https://fonts.googleapis.com">
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
            <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap" rel="stylesheet">
          </head>
          <body style="margin:0;padding:24px;font-family:'Inter',sans-serif;background:#f8fafc;color:#0f172a;">
            <h3 style="margin-top:0;">${safeTitle}</h3>
            <pre style="white-space:pre-wrap;word-break:break-word;line-height:1.5;background:#fff;border:1px solid #e2e8f0;border-radius:10px;padding:16px;">${safeText}</pre>
          </body>
        </html>
      `);
        newWindow.document.close();
      }
      return;
    }

    if (!file?.url) return;

    // 🔹 If it's an image or PDF, open it directly
    if (fileType.startsWith('image/') || fileType === 'application/pdf') {
      const newWindow = window.open();
      if (newWindow) {
        newWindow.document.write(`
        <html>
          <head>
            <title>${file.name}</title>
          </head>
          <body style="margin:0;display:flex;justify-content:center;align-items:center;background:#111;">
            <embed src="${file.url}"
                    type="${file.type}"
                    style="width:100%;height:100vh;object-fit:contain;" />
          </body>
        </html>
      `);
        newWindow.document.close();
      }
    }
    // 🔹 For other file types (docx, txt, etc.), trigger download instead
    else {
      const link = document.createElement('a');
      link.href = file.url;
      link.download = file.name;
      link.click();
    }
  }

  deleteUploadedReport(file: any, event?: Event) {
    event?.stopPropagation();
    event?.preventDefault();
    const target = (event?.currentTarget || event?.target) as HTMLElement | undefined;
    const reportId = Number(file?.id ?? file?.report_id);
    const isSavedReport = Number.isFinite(reportId) && reportId > 0;

    this.confirmationService.confirm({
      key: 'reportDeleteConfirm',
      target,
      message: isSavedReport
        ? 'Delete this report permanently?'
        : 'Remove this unsaved report from the current screen?',
      header: 'Confirm Deletion',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Delete',
      rejectLabel: 'Cancel',
      acceptButtonStyleClass: 'report-confirm-accept',
      rejectButtonStyleClass: 'report-confirm-reject',
      accept: () => {
        if (!isSavedReport) {
          this.removeLocalReportFromGallery(file);
          this.toast.add({
            severity: 'success',
            summary: 'Removed',
            detail: 'Unsaved report removed from the current screen.'
          });
          return;
        }

        this.prescriptionsService.deleteReport(reportId).subscribe({
          next: (res: any) => {
            if (res?.success) {
              this.removeReportFromGallery(reportId);
              this.toast.add({
                severity: 'success',
                summary: 'Deleted',
                detail: 'Report deleted successfully.'
              });
              return;
            }

            this.toast.add({
              severity: 'error',
              summary: 'Delete Failed',
              detail: res?.message || 'Unable to delete report.'
            });
          },
          error: (err) => {
            this.toast.add({
              severity: 'error',
              summary: 'Delete Failed',
              detail: err?.error?.message || 'Unable to delete report.'
            });
          }
        });
      }
    });
  }

  saveTextReport() {
    const patientId = Number(this.currentPatientId || 0);
    const text = String(this.reportTextContent || '').trim();
    const title = String(this.reportTextTitle || '').trim();

    if (!patientId) {
      this.toast.add({
        severity: 'warn',
        summary: 'Patient Missing',
        detail: 'Select a patient before saving a text report.'
      });
      return;
    }

    if (!text) {
      this.toast.add({
        severity: 'warn',
        summary: 'No Text',
        detail: 'Enter report text before saving.'
      });
      return;
    }

    this.isSavingTextReport = true;
    this.prescriptionsService.uploadTextReport({
      patient_id: patientId,
      report_title: title || undefined,
      report_text: text
    }).subscribe({
      next: (res: any) => {
        this.isSavingTextReport = false;
        if (res?.success) {
          this.mergeReports(Array.isArray(res?.data) ? res.data : []);
          this.reportTextTitle = '';
          this.reportTextContent = '';
          this.toast.add({
            severity: 'success',
            summary: 'Saved',
            detail: 'Text report saved successfully.'
          });
          return;
        }

        this.toast.add({
          severity: 'error',
          summary: 'Save Failed',
          detail: res?.message || 'Unable to save text report.'
        });
      },
      error: (err) => {
        this.isSavingTextReport = false;
        this.toast.add({
          severity: 'error',
          summary: 'Save Failed',
          detail: err?.error?.message || 'Unable to save text report.'
        });
      }
    });
  }

  private removeLocalReportFromGallery(fileToRemove: any) {
    this.uploadsByDate = (this.uploadsByDate || [])
      .map((group: any) => ({
        ...group,
        files: (group?.files || []).filter((f: any) => f !== fileToRemove)
      }))
      .filter((group: any) => (group?.files || []).length > 0);
  }

  private removeReportFromGallery(reportId: number) {
    this.uploadsByDate = (this.uploadsByDate || [])
      .map((group: any) => ({
        ...group,
        files: (group?.files || []).filter((f: any) => Number(f?.id) !== reportId)
      }))
      .filter((group: any) => (group?.files || []).length > 0);
  }

  uploadPendingFiles() {
    if (!this.pendingFiles || this.pendingFiles.length === 0) return;

    const formData = new FormData();
    formData.append('patient_id', this.currentPatientId.toString());
    // formData.append('prescription_id', prescriptionId.toString());

    this.pendingFiles.forEach((file: File) => {
      formData.append('files[]', file, file.name);
    });

    this.prescriptionsService.uploadReports(formData).subscribe({
      next: (uploadRes: any) => {
        if (uploadRes.success) {
          // this.mergeReports(uploadRes.data);
          // this.pendingFiles = [];
          this.closeUploadReportDialog();
          this.toast.add({
            severity: 'success',
            summary: 'Upload Complete'
          });
        }
      },
      error: (err) => {
        this.toast.add({
          severity: 'error',
          summary: 'Upload Failed',
          detail: 'There was an error uploading the reports. Please try again.'
        });
      }
    });
  }

  private mergeReports(newReports: any[]) {
    newReports.forEach(r => {
      const date = r.uploaded_at.split(' ')[0];
      let group = this.uploadsByDate.find(g => g.date === date);
      if (!group) {
        group = { date, files: [] };
        this.uploadsByDate.push(group);
      }
      group.files.push(r);
    });
  }

  closeUploadReportDialog() {
    this.openUploadReportDialog = false;
    this.pendingFiles = [];
    this.reportTextTitle = '';
    this.reportTextContent = '';
  }

  closePaymentDialog() {
    this.openPaymentDialog = false;
    this.latestDueAmount = 0;
    this.latestDuePayment = null;
    this.payAmount = null;
    this.selectedPaymentMode = null;
  }

  private toNonNegativeNumber(value: any): number {
    if (value === null || value === undefined) return 0;

    const normalized = String(value).replace(/[^0-9.-]/g, '');
    const num = Number(normalized);
    if (!Number.isFinite(num) || Number.isNaN(num)) return 0;
    return Math.max(0, num);
  }

  onPayAmountChange(value: any) {
    const next = this.toNonNegativeNumber(value);
    const max = this.toNonNegativeNumber(this.latestDueAmount);
    this.payAmount = max > 0 ? Math.min(next, max) : null;
  }

  // getPaymentHistory() {
  //   console.log(this.currentPatientId);
  //   const payload: any = {
  //     patient_id: this.currentPatientId,
  //   }
  //   this.patientRegistrationService.getPaymentHistory(payload).subscribe({
  //     next: (res: any) => {
  //       console.log(res);

  //       if (res.success) {
  //         this.paymentHistory = res.history || [];
  //         this.pagination = res.pagination;
  //       }
  //     }
  //   })
  // }

  loadPayments(event: any) {
    if (!this.currentPatientId || this.currentPatientId <= 0 || !this.openPaymentDialog) {
      return;
    }

    const rows = Number(event?.rows) > 0 ? Number(event.rows) : this.pagination.per_page || 10;
    const first = Number(event?.first) >= 0 ? Number(event.first) : 0;
    const page = Math.floor(first / rows) + 1;

    const payload = {
      patient_id: this.currentPatientId,
      page: page,
      per_page: rows
    };

    this.patientRegistrationService.getPaymentHistory(payload)
      .subscribe((res: any) => {
        if (res.success) {
          const rows = res.history ?? res.data ?? [];
          this.paymentHistory = rows;
          this.pagination.total = res.pagination.total;
          this.pagination.per_page = res.pagination.per_page;
          this.pagination.current_page = res.pagination.current_page;

          // Latest = first row (DESC order), with response-shape fallbacks
          this.latestDuePayment = rows?.[0] ?? null;
          const dueFromLatestRow = this.toNonNegativeNumber(
            this.latestDuePayment?.due_amount ??
            this.latestDuePayment?.raw_response?.meta?.personal_dues ??
            0
          );
          const selectedPatientRow = this.patientList.find((p: any) => Number(p?.id) === this.currentPatientId);
          const dueFromPatientRow = this.toNonNegativeNumber(selectedPatientRow?.personal_dues ?? 0);

          // Keep settlement source aligned with main patient table due.
          // Dialog table is historical snapshots and can differ per row.
          this.latestDueAmount = dueFromPatientRow > 0 ? dueFromPatientRow : dueFromLatestRow;

          if (this.latestDueAmount === 0 && this.queryDueAmount > 0) {
            this.latestDueAmount = this.queryDueAmount;
          }

          // Default pay amount = full due
          this.payAmount = this.latestDueAmount > 0 ? this.latestDueAmount : null;

          this.selectedPaymentMode = null; // reset on reload

          if (!rows.length && page === 1) {
            this.toast.add({
              severity: 'info',
              summary: 'No Payment Records',
              detail: this.latestDueAmount > 0
                ? 'No payment history found, but pending dues can still be settled.'
                : 'No payment records found for this patient.'
            });
          }
        }
      }, () => {
        this.paymentHistory = [];
        this.toast.add({
          severity: 'error',
          summary: 'Load Failed',
          detail: 'Unable to load payment history. Please try again.'
        });
      });
  }

  openPaymentHistoryDialog(patientId?: number) {
    if (patientId && patientId > 0) {
      this.currentPatientId = patientId;
    }

    if (!this.currentPatientId || this.currentPatientId <= 0) {
      this.toast.add({
        severity: 'warn',
        summary: 'Patient Required',
        detail: 'Please select a patient first.'
      });
      return;
    }

    // Instant fallback due value from list row until API returns latest history
    const selectedPatientRow = this.patientList.find((p: any) => Number(p?.id) === this.currentPatientId);
    
    if (selectedPatientRow) {
      this.selectedPatient = selectedPatientRow;
    } else {
      // Fetch single patient if not found in list so we have their name/number for the modal header
      this.patientRegistrationService.getSinglePatient(this.currentPatientId).subscribe((res: any) => {
        if (res.success && res.data) {
          this.selectedPatient = res.data;
          // Construct full_name if missing
          const firstName = String(res.data.first_name || '').trim();
          const middleName = String(res.data.middle_name || '').trim();
          const lastName = String(res.data.last_name || '').trim();
          this.selectedPatient.full_name = [firstName, middleName, lastName].filter(Boolean).join(' ').trim() || String(res.data.full_name || '').trim();
        }
      });
    }

    let rowDue = this.toNonNegativeNumber(selectedPatientRow?.personal_dues ?? 0);
    
    if (rowDue === 0 && this.queryDueAmount > 0) {
      rowDue = this.queryDueAmount;
    }

    this.latestDueAmount = rowDue;
    this.payAmount = this.latestDueAmount > 0 ? this.latestDueAmount : null;
    this.paymentHistory = [];
    this.pagination.current_page = 1;
    this.pagination.per_page = 10;
    this.pagination.total = 0;
    this.pagination.last_page = 1;
    this.pagination.has_more = false;

    this.openPaymentDialog = true;
    this.loadPayments({ first: 0, rows: 10 });
  }

  settleDues(payment: any) {
    // You now have:
    // payment.due_amount
    // payment.prescription_id
    // payment.appointment_id

    // Example:
    this.selectedDueAmount = payment.due_amount;
    this.selectedPrescriptionId = payment.prescription_id;

    // Open dialog / call API / whatever
  }

  settleLatestDue() {
    if (!this.selectedPaymentMode) {
      this.toast.add({
        severity: 'warn',
        summary: 'Payment Mode Required',
        detail: 'Please select a payment mode before settling dues.'
      });
      return;
    }

    const latestDue = this.toNonNegativeNumber(this.latestDueAmount);
    const amountToPay = this.toNonNegativeNumber(this.payAmount);

    if (latestDue <= 0) {
      this.toast.add({
        severity: 'warn',
        summary: 'No Dues',
        detail: 'There are no pending dues for this patient.'
      });
      return;
    }

    if (!amountToPay || amountToPay <= 0) {
      this.toast.add({
        severity: 'warn',
        summary: 'Invalid Amount',
        detail: 'Enter a valid cash amount before saving.'
      });
      return;
    }

    if (amountToPay > latestDue) {
      this.toast.add({
        severity: 'warn',
        summary: 'Invalid Amount',
        detail: 'Pay amount cannot exceed latest due.'
      });
      this.payAmount = latestDue;
      return;
    }

    const payload = {
      patient_id: this.currentPatientId,
      amount: this.payAmount,
      payment_mode: this.selectedPaymentMode,
      prescription_id: this.queryPrescriptionId > 0 ? this.queryPrescriptionId : (this.latestDuePayment?.prescription_id || this.selectedPrescriptionId)
    };

    this.settlingPayment = true;

    this.patientRegistrationService.settleDues(payload)
      .subscribe({
        next: () => {
          const updatedDue = Math.max(0, latestDue - amountToPay);
          this.latestDueAmount = updatedDue;
          this.payAmount = updatedDue > 0 ? updatedDue : null;

          // Keep patient table row in sync immediately (avoids stale fallback overriding refreshed due).
          const rowIndex = this.patientList.findIndex((p: any) => Number(p?.id) === this.currentPatientId);
          if (rowIndex >= 0) {
            this.patientList[rowIndex] = {
              ...this.patientList[rowIndex],
              personal_dues: updatedDue
            };
          }

          this.toast.add({
            severity: 'success',
            summary: 'Dues Settled',
            detail: updatedDue > 0
              ? `Payment recorded. Remaining due: ₹${updatedDue}`
              : 'Payment recorded successfully. All dues are cleared.'
          });

          this.settlingPayment = false;

          // Reload table & dues
          this.loadPayments({ first: 0, rows: this.pagination.per_page });
          this.getPatient();
        },
        error: () => {
          this.settlingPayment = false;

          this.toast.add({
            severity: 'error',
            summary: 'Failed to Settle Dues',
            detail: 'Cash payment failed to record.'
          });
        }
      });
  }

  canSettlePayment(): boolean {
    const latestDue = this.toNonNegativeNumber(this.latestDueAmount);
    const amountToPay = this.toNonNegativeNumber(this.payAmount);

    return (
      !!this.currentPatientId &&
      latestDue > 0 &&
      !!this.selectedPaymentMode &&
      amountToPay > 0 &&
      amountToPay <= latestDue &&
      !this.settlingPayment
    );
  }

  get remainingAfterPay(): number {
    const due = this.toNonNegativeNumber(this.latestDueAmount);
    const pay = this.toNonNegativeNumber(this.payAmount);
    return Math.max(0, due - pay);
  }

  payFullDue(): void {
    const due = this.toNonNegativeNumber(this.latestDueAmount);
    this.payAmount = due > 0 ? due : null;
  }

  paymentModeLabel(mode: string | null | undefined): string {
    const key = String(mode || '').toLowerCase();
    const match = this.paymentModes.find(m => m.value === key);
    if (match) return match.label;
    return mode ? String(mode) : '—';
  }

  paymentModeIcon(mode: string | null | undefined): string {
    switch (String(mode || '').toLowerCase()) {
      case 'cash':
        return 'pi pi-money-bill';
      case 'upi':
        return 'pi pi-mobile';
      case 'card':
        return 'pi pi-credit-card';
      case 'cheque':
        return 'pi pi-file';
      default:
        return 'pi pi-wallet';
    }
  }

  loadPendingRegistrations(
    status: 'pending' | 'approved' | 'rejected' = this.pendingStatusFilter,
    page = this.pendingPage,
    resetPage = false
  ) {
    if (resetPage) {
      page = 1;
      this.pendingPage = 1;
    }

    this.pendingStatusFilter = status;
    this.pendingPage = page;
    this.cancelReject();
    this.pendingLoading = true;

    this.patientRegistrationService
      .getPendingRegistrations(status, page, this.pendingPerPage, this.pendingSearch)
      .subscribe({
        next: (res: any) => {
          this.pendingRegistrations = res.data || [];
          const meta = res.meta || {};
          this.pendingTotal = Number(meta.total) || this.pendingRegistrations.length;
          this.pendingLastPage = Number(meta.last_page) || 1;
          this.pendingFrom = Number(meta.from) || (this.pendingRegistrations.length ? 1 : 0);
          this.pendingTo = Number(meta.to) || this.pendingRegistrations.length;
          this.pendingCount = Number(res.pending_count ?? this.pendingCount) || 0;

          if (!this.pendingRegistrations.length && this.pendingPage > 1) {
            this.loadPendingRegistrations(status, this.pendingPage - 1);
            return;
          }

          if (this.selectedPendingRegistration) {
            const stillSelected = this.pendingRegistrations.find(
              (row) => row.id === this.selectedPendingRegistration.id
            );
            this.selectedPendingRegistration = stillSelected || this.pendingRegistrations[0] || null;
          } else {
            this.selectedPendingRegistration = this.pendingRegistrations[0] || null;
          }

          this.pendingLoading = false;
          this.cdr.detectChanges();
        },
        error: () => {
          this.pendingLoading = false;
          this.toast.add({
            severity: 'error',
            summary: 'Error',
            detail: `Failed to load ${status} registrations.`,
          });
        },
      });
  }

  onPendingSearchChange(): void {
    if (this.pendingSearchTimer) {
      clearTimeout(this.pendingSearchTimer);
    }
    this.pendingSearchTimer = setTimeout(() => {
      this.loadPendingRegistrations(this.pendingStatusFilter, 1, true);
    }, 300);
  }

  clearPendingSearch(): void {
    this.pendingSearch = '';
    this.loadPendingRegistrations(this.pendingStatusFilter, 1, true);
  }

  selectPendingRegistration(row: any): void {
    this.selectedPendingRegistration = row;
    this.cancelReject();
  }

  pendingPagePrev(): void {
    if (this.pendingPage <= 1 || this.pendingLoading) {
      return;
    }
    this.loadPendingRegistrations(this.pendingStatusFilter, this.pendingPage - 1);
  }

  pendingPageNext(): void {
    if (this.pendingPage >= this.pendingLastPage || this.pendingLoading) {
      return;
    }
    this.loadPendingRegistrations(this.pendingStatusFilter, this.pendingPage + 1);
  }

  get pendingPageLabel(): string {
    if (!this.pendingTotal) {
      return '0 registrations';
    }
    return `${this.pendingFrom}-${this.pendingTo} of ${this.pendingTotal}`;
  }

  openApprovalQueue(): void {
    this.showOnlineQueue = true;
    this.pendingSearch = '';
    this.selectedPendingRegistration = null;
    this.cancelReject();
    this.loadPendingRegistrations('pending', 1, true);
  }

  closeApprovalQueue(): void {
    this.showOnlineQueue = false;
    this.selectedPendingRegistration = null;
    this.cancelReject();
  }

  startReject(item: any): void {
    const target = item || this.selectedPendingRegistration;
    this.rejectingId = target?.id ?? null;
    this.rejectReason = '';
    if (target) {
      this.selectedPendingRegistration = target;
    }
  }

  cancelReject(): void {
    this.rejectingId = null;
    this.rejectReason = '';
  }

  @HostListener('document:keydown.escape')
  onApprovalQueueEscape(): void {
    if (!this.showOnlineQueue) {
      return;
    }
    if (this.rejectingId !== null) {
      this.cancelReject();
      return;
    }
    this.closeApprovalQueue();
  }

  approvePending(item: any) {
    const target = item || this.selectedPendingRegistration;
    if (!target?.id) {
      return;
    }

    this.patientRegistrationService.approvePendingRegistration(target.id).subscribe({
      next: (res: any) => {
        this.toast.add({
          severity: 'success',
          summary: 'Approved',
          detail: res.message || 'Patient created.',
        });
        this.loadPendingRegistrations();
        this.getPatient();
      },
      error: (err: any) => {
        this.toast.add({
          severity: 'error',
          summary: 'Error',
          detail: err?.error?.message || 'Approval failed.',
        });
      },
    });
  }

  rejectPending(item: any) {
    this.startReject(item);
  }

  confirmReject(item: any) {
    const target = item || this.selectedPendingRegistration;
    if (!target?.id) {
      return;
    }

    this.patientRegistrationService.rejectPendingRegistration(target.id, this.rejectReason.trim() || undefined).subscribe({
      next: (res: any) => {
        this.toast.add({
          severity: 'info',
          summary: 'Rejected',
          detail: res.message || 'Registration rejected.',
        });
        this.cancelReject();
        this.loadPendingRegistrations();
      },
      error: (err: any) => {
        this.toast.add({
          severity: 'error',
          summary: 'Error',
          detail: err?.error?.message || 'Rejection failed.',
        });
      },
    });
  }

  pendingFullName(item: any): string {
    return [item.first_name, item.middle_name, item.last_name].filter(Boolean).join(' ');
  }

  getInitials(item: any): string {
    const f = item.first_name ? item.first_name[0] : '';
    const l = item.last_name ? item.last_name[0] : '';
    return (f + l).toUpperCase() || 'P';
  }
}








